import { RESET_FACTOR } from "constants/formConstants";
import { SET_FACTOR, SET_FACTORS, SET_FACTOR_PATTERN } from "../../constants/factorConstants";

export const setFactor = (factor) => {
  return {
    type: SET_FACTOR,
    factor,
  };
};
export const resetFactor = () => {
  return {
    type: RESET_FACTOR,
  };
};

export const setFactors = (factors, filtered = false) => {
  return {
    type: SET_FACTORS,
    factors,
    filtered,
  };
};
export const setFactorPattern = (factorPattern) => {
  return {
    type: SET_FACTOR_PATTERN,
    factorPattern,
  };
};
